import React from "react";
export const MainHeader = ({ title }) => (
  <div>
    <h1 className="text-[2.25rem] leading-[2.5rem] mt-5 mb-6 font-[700]">
      {title}
    </h1>
  </div>
);
